import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useLocation, Link } from "react-router-dom";
import { Input } from "@nextui-org/react";

import Swal from "sweetalert2";

import {
  FaCashRegister,
  FaExclamationCircle,
  FaPray,
  FaFileMedical,
  FaPenSquare,
  FaPaperPlane,
  FaRegEdit,
  FaRegTrashAlt,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
const StockTran = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const [stockTranLists, setStockTranLists] = useState([]);
  const [tranCount, setTranCount] = useState("");

  const [searchList, setSearchList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [showOri, setShowOri] = useState(true);

  const [branchesLists, setBranchesLists] = useState([]);
  const [branchFilterLists, setBranchFilterLists] = useState([]);
  const [showBranchFilter, setShowBranchFilter] = useState(false);
  const [showOrigin, setShowOrigin] = useState(true);
  const [showSearchDate, setShowSearchDate] = useState(false);
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const [searchByDateList, setSearchByDateList] = useState([]);

  // const _export = React.useRef(null);
  // const excelExport = () => {
  //   if (_export.current !== null) {
  //     console.log(_export.current.props.data);
  //     _export.current.props.data.map(function (element, index) {
  //       element.date = element.date.split("T")[0];
  //     });
  //     _export.current.save();
  //   }
  // };

  const handleChoose = (event) => {
    console.log(event, "branch");

    setBranchFilterLists(
      stockTranLists.filter((el) => el.relatedBranch._id == event),
    );

    setShowOrigin(false);
    setShowSearch(false);
    setShowBranchFilter(true);
    setShowSearchDate(false);
  };

  const handleFilterDate = () => {
    console.log(from, "from");
    console.log(to, "to");
    setSearchByDateList(
      stockTranLists.filter(
        (el) => el.date >= from && (el.date < to || el.date === to),
      ),
    );

    setShowSearchDate(false);
    setShowSearchDate(true);
    setShowBranchFilter(false);

    setShowOrigin(false);
  };

  const handleDelete = (event) => {
    api
      .delete("stock-transfer/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = stockTranLists.filter((item) => item._id !== event);
        setStockTranLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const search = (val) => {
    if (val) {
      setSearchList(
        stockTranLists.filter(
          (el) => el.requestedBy == val || el.requestNo == val,
        ),
      );
      setShowSearch(true);
      setShowBranchFilter(false);
      setShowSearchDate(false);

      setShowOrigin(false);
    } else {
      setShowSearch(false);
      setShowBranchFilter(false);
      setShowSearchDate(false);

      setShowOrigin(true);
    }
  };

  useEffect(() => {
    const getStockTranLists = async () => {
      try {
        const res = await api.get(
          "purchase-requests",
          //'http://localhost:9000/api/treatments'
        );
        setStockTranLists(res.data.list.filter((el) => el.relatedApprove));
        console.log(
          res.data.list.filter((el) => el.relatedApprove),
          "p a l",
        );
        setTranCount(res.data.list.length);
        // setTreatmentLists(res.data.list)

        console.log(res.data.list, "pur t");
      } catch (err) {
        alert(err.message);
      }
    };
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchesLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };

    getBranches();

    getStockTranLists();
  }, []);

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">
                      Purchase Approve List &nbsp;
                      {/* <b className='bg-red rounded-5 px-2 py-2'>{tranCount}+</b> */}
                    </li>{" "}
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-6">
                  <div className="row">
                    <div className="form-group col-md-3">
                      <label>From</label>
                      <input
                        type="date"
                        name="from"
                        id="from"
                        onChange={(e) => setFrom(e.target.value)}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-3">
                      <label>To</label>
                      <input
                        type="date"
                        name="to"
                        id="to"
                        onChange={(e) => setTo(e.target.value)}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-2">
                      <button
                        className="btn btn-sm btn-primary"
                        style={{ marginTop: "40px" }}
                        onClick={handleFilterDate}
                      >
                        Search
                      </button>
                    </div>
                    <div className="col-4" style={{ marginTop: "2.6em" }}>
                      <div className="form-group">
                        <select
                          name="currency"
                          id=""
                          className="form-control "
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => handleChoose(e.target.value)}
                        >
                          <option hidden>Filter By Branches</option>
                          {branchesLists.map((option, i) => (
                            <option value={option._id}>{option.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="offset-2 col-4" style={{ marginTop: "2.3em" }}>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        type="search"
                        className="form-control rounded ml-1"
                        style={{ borderRadius: "12px" }}
                        id="search_code"
                        labelPlaceholder="Search"
                        onChange={(e) => search(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 ">
                      {/* <Link
                        to='/stock-req-create'
                        className='btn btn-dark'
                        style={{
                          borderRadius: '7px',
                          backgroundColor: 'dark',
                          color: 'white'
                        }}
                      >
                        Create
                      </Link> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  <div className="card">
                    {/* <div className="card-header">
                      <div className="row justify-content-between">
                        <span className="float-right">
                          <a href="/StockTran_type" className="btn btn-primary">
                            StockTran Type
                          </a>
                           <button
                              type="button"
                              className="btn btn-primary"
                              onClick={excelExport}>
                              Export Excel
                            </button>
                        </span>
                      </div>
                      <div className="row" id="trial_balance"></div>
                    </div> */}

                    <div className="card-body">
                      {/* Export data in Excel */}
                      {/* <ExcelExport data={StockTranLists} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="date"
                          title="Date"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="relatedBankAccount.name"
                          title="Bank Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedCashAccount.name"
                          title="Cash Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedAccounting.name"
                          title="Account"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="remark"
                          title="Remark"
                          width={150}
                        />
                      </ExcelExport> */}
                      {/* Export Data in Excel end */}
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="table-responsive text-black"
                            id="slimtest2"
                          >
                            <table
                              className="table table-hover"
                              id="filter_date"
                            >
                              <thead className="">
                                <tr>
                                  <th>#</th>
                                  <th>Purchase Code</th>
                                  <th>Purchase Date</th>
                                  <th>Required Date</th>
                                  <th>Branch</th>

                                  {/* <th>Check</th> */}
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>

                              {showSearch && (
                                <tbody>
                                  {searchList
                                    .slice(0)
                                    .reverse()
                                    .map((st, i) => (
                                      <tr>
                                        <td>{++i}</td>

                                        <td>{st.code}</td>

                                        <td>
                                          {st.purchaseDate
                                            ? st.purchaseDate.split("T")[0]
                                            : ""}
                                        </td>

                                        <td>
                                          {st.requiredDate
                                            ? st.requiredDate.split("T")[0]
                                            : ""}
                                        </td>

                                        <td>
                                          {st.relatedBranch
                                            ? st.relatedBranch.name
                                            : "HO"}
                                        </td>

                                        <td className="text-center">
                                          {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                          <Link
                                            to={"/appr-detail/" + st._id}
                                            className="btn btn-sm btn-dark"
                                          >
                                            <abbr title="Detail">
                                              <FaExclamationCircle />
                                            </abbr>
                                          </Link>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              )}

                              {showOrigin && (
                                <tbody>
                                  {stockTranLists
                                    .slice(0)
                                    .reverse()
                                    .map((st, i) => (
                                      <tr>
                                        <td>{++i}</td>

                                        <td>{st.code}</td>

                                        <td>
                                          {st.purchaseDate
                                            ? st.purchaseDate.split("T")[0]
                                            : ""}
                                        </td>

                                        <td>
                                          {st.requiredDate
                                            ? st.requiredDate.split("T")[0]
                                            : ""}
                                        </td>

                                        <td>
                                          {st.relatedBranch
                                            ? st.relatedBranch.name
                                            : "HO"}
                                        </td>

                                        <td className="text-center">
                                          {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                          <Link
                                            to={"/appr-detail/" + st._id}
                                            className="btn btn-sm btn-dark"
                                          >
                                            <abbr title="Detail">
                                              <FaExclamationCircle />
                                            </abbr>
                                          </Link>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              )}
                              {showBranchFilter && (
                                <tbody>
                                  {branchFilterLists
                                    .slice(0)
                                    .reverse()
                                    .map((st, i) => (
                                      <tr>
                                        <td>{++i}</td>

                                        <td>{st.code}</td>

                                        <td>
                                          {st.purchaseDate
                                            ? st.purchaseDate.split("T")[0]
                                            : ""}
                                        </td>

                                        <td>
                                          {st.requiredDate
                                            ? st.requiredDate.split("T")[0]
                                            : ""}
                                        </td>

                                        <td>
                                          {st.relatedBranch
                                            ? st.relatedBranch.name
                                            : "HO"}
                                        </td>

                                        <td className="text-center">
                                          {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                          <Link
                                            to={"/appr-detail/" + st._id}
                                            className="btn btn-sm btn-dark"
                                          >
                                            <abbr title="Detail">
                                              <FaExclamationCircle />
                                            </abbr>
                                          </Link>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              )}
                              {showSearchDate && (
                                <tbody>
                                  {searchByDateList
                                    .slice(0)
                                    .revers()
                                    .map((st, i) => (
                                      <tr>
                                        <td>{++i}</td>

                                        <td>{st.code}</td>

                                        <td>
                                          {st.purchaseDate
                                            ? st.purchaseDate.split("T")[0]
                                            : ""}
                                        </td>

                                        <td>
                                          {st.requiredDate
                                            ? st.requiredDate.split("T")[0]
                                            : ""}
                                        </td>

                                        <td>
                                          {st.relatedBranch
                                            ? st.relatedBranch.name
                                            : "HO"}
                                        </td>

                                        <td className="text-center">
                                          {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                          <Link
                                            to={"/appr-detail/" + st._id}
                                            className="btn btn-sm btn-dark"
                                          >
                                            <abbr title="Detail">
                                              <FaExclamationCircle />
                                            </abbr>
                                          </Link>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <Treatement
                open={open}
                close={() => setOpen(false)}
                setTreatmentLists={setTreatmentLists}
                treatmentLists={treatmentLists}
              /> */}
            </div>
          </section>
        </div>

    </>
  );
};

export default StockTran;
